module.exports = __webpack_public_path__ + "img/category_11.673fd65a.png";